
export enum LeavePageActionResult {
  Cancel = 'Cancel',
  Confirm = 'Confirm'
}
